import React, { ComponentType } from "react"
import { NodeProps } from "reactflow"
import { Restore as ClientRespondedIcon } from "@material-ui/icons"

import { BlockNodeData } from "@/protocols/chatBotFlow"

import useChatBotFlowBlockDetails from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useChatBotFlowBlockDetails"

import BaseBlock from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BaseBlock"
import BlockBodySection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySection"
import BlockBodySectionGroup from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionGroup"
import CreateConditionButton from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/CreateConditionButton"
import AIFollowUpAttemptSectionEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/AIFollowUpBlock/AIFollowUpAttemptSectionEditor"
import AIFollowUpAttemptSectionContainer from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/AIFollowUpBlock/AIFollowUpAttemptSectionContainer"
import AIFollowUpClientRepliedConditionSection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/AIFollowUpBlock/AIFollowUpClientRepliedConditionSection"
import AIFollowUpAttemptsExhaustedConditionSection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/AIFollowUpBlock/AIFollowUpAttemptsExhaustedConditionSection"

const AIFollowUpBlock: ComponentType<NodeProps<BlockNodeData>> = (node) => {
	const chatBotFlowBlockDetails = useChatBotFlowBlockDetails({ chatBotFlowBlockId: node.data.chatBotFlowBlockId })

	const isWabaChannel = node.data.chatBotFlowChannelType === "waba"

	const attempts = chatBotFlowBlockDetails.content.aiFollowUpData?.attempts || []

	return (
		<BaseBlock
			node={node}
		>
			<BlockBodySectionGroup>
				{attempts.map((attempt, attemptIndex) => (
					<BlockBodySection
						key={attemptIndex}
						fullWidth
					>
						<AIFollowUpAttemptSectionEditor
							attempt={attempt}
							isWabaChannel={isWabaChannel}
							onSave={(updatedAttempt) => chatBotFlowBlockDetails.changeContent({ aiFollowUpData: { attempts: attempts.map((currentAttempt, currentIndex) => currentIndex === attemptIndex ? updatedAttempt : currentAttempt) } })}
							onDelete={() => chatBotFlowBlockDetails.changeContent({ aiFollowUpData: { attempts: attempts.filter((_, currentIndex) => currentIndex !== attemptIndex) } })}
						>
							<AIFollowUpAttemptSectionContainer
								attempt={attempt}
								attemptIndex={attemptIndex}
								isWabaChannel={isWabaChannel}
							/>
						</AIFollowUpAttemptSectionEditor>
					</BlockBodySection>
				))}

				<BlockBodySection>
					<AIFollowUpAttemptSectionEditor
						hideChildSelection
						isWabaChannel={isWabaChannel}
						onSave={(newAttempt) => chatBotFlowBlockDetails.changeContent({ aiFollowUpData: { attempts: [...attempts, newAttempt] } })}
					>
						<CreateConditionButton
							color={chatBotFlowBlockDetails.blockThemeConfig.color.blockIcon}
							chatBotFlowBlockId={node?.data?.chatBotFlowBlockId}
							errorType="ai_follow_up_block_missing_attempt"
						>
							Adicionar tentativa de contato
						</CreateConditionButton>
					</AIFollowUpAttemptSectionEditor>
				</BlockBodySection>
			</BlockBodySectionGroup>

			<BlockBodySectionGroup>
				<AIFollowUpClientRepliedConditionSection
					nextChatBotFlowBlockRules={chatBotFlowBlockDetails.nextChatBotFlowBlockRules}
					text="Se o cliente responder"
					customIcon={<ClientRespondedIcon />}
				/>

				<AIFollowUpAttemptsExhaustedConditionSection
					nextChatBotFlowBlockRules={chatBotFlowBlockDetails.nextChatBotFlowBlockRules}
					text="Tentativas de contato esgotadas"
				/>
			</BlockBodySectionGroup>
		</BaseBlock>
	)
}

export default AIFollowUpBlock
